import { AppsPage } from '~/components/pages/AppsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';

export const AppsRoute: React.FC = () => (
  <DashboardTemplate>
    <AppsPage />
  </DashboardTemplate>
);
